// src/components/ToastNotification.js
import React from "react";
import { createPortal } from "react-dom";
import "../styles/toast.css";

const ToastNotification = ({ message }) => {
  return createPortal(
    <div className="toast-notification">
      <span className="spinner" />
      <span style={{ marginLeft: "10px" }}>{message}</span>
    </div>,
    document.getElementById("toast-root")
  );
};

export default ToastNotification;